var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "copy-favourite-list-model",
        title: "Copy Favourites",
        "no-fade": "",
        size: "lg"
      },
      on: {
        change: _vm.onModalChange,
        hide: _vm.onModalChange,
        show: _vm.onModalChange
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-btn",
                {
                  on: {
                    click: function($event) {
                      _vm.modalOpen = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { disabled: !_vm.canCopy },
                  on: { click: _vm.copyFavList }
                },
                [_vm._v("Copy Favourites")]
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.modalOpen,
        callback: function($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen"
      }
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "pb-3" }, [
        _vm._v(
          "\n        This can copy from selected user's favourites or their favourite lists to your favourites or one of your favourite list.\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "selection-container" },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                "label-cols": "3",
                "label-size": "sm",
                label: "From Favourites or List"
              }
            },
            [
              _c(
                "b-form-select",
                {
                  ref: "from_list",
                  model: {
                    value: _vm.fromListId,
                    callback: function($$v) {
                      _vm.fromListId = $$v
                    },
                    expression: "fromListId"
                  }
                },
                [
                  _c("option", { attrs: { value: "-1" } }, [
                    _vm._v("All Favourites")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.fromFavList, function(item) {
                    return _c("option", { domProps: { value: item.id } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.name) +
                          "\n                "
                      )
                    ])
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                "label-cols": "3",
                "label-size": "sm",
                label: "To Favourites or List"
              }
            },
            [
              _c(
                "b-form-select",
                {
                  ref: "from_list",
                  model: {
                    value: _vm.toListId,
                    callback: function($$v) {
                      _vm.toListId = $$v
                    },
                    expression: "toListId"
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("-")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "-1" } }, [
                    _vm._v("My Favourites")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.toFavList, function(item) {
                    return _c("option", { domProps: { value: item.id } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.name) +
                          "\n                "
                      )
                    ])
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b75e1d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b75e1d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/CopyFavListModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7b75e1d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/CopyFavListModal.vue
// module chunks = 0